import { apiClient } from '@shared/api/client';
import {
  UserDTO,
  UserSessionDTO,
  TenantAccessListResponseDTO,
  SwitchTenantRequestDTO,
  SwitchTenantResponseDTO,
  RefreshSessionContextResponseDTO,
} from '../dtos';

/**
 * Authentication API for backend communication
 * Enhanced with multi-tenant support
 * Note: Authentication is handled by Cognito, multi-tenant session management by backend
 */
export const authApi = {
  // Legacy endpoint - Get current user from backend (protected endpoint)
  getCurrentUser: async (): Promise<UserDTO> => {
    const response = await apiClient.get<UserDTO>('/users/me');
    return (response.data || response) as UserDTO;
  },

  // Multi-tenant endpoints

  // Get current user session with multi-tenant context
  getCurrentSession: async (): Promise<UserSessionDTO> => {
    const response = await apiClient.get<UserSessionDTO>('/auth/me');
    return (response.data || response) as UserSessionDTO;
  },

  // Get user's accessible tenants
  getAccessibleTenants: async (): Promise<TenantAccessListResponseDTO> => {
    const response = await apiClient.get<TenantAccessListResponseDTO>('/auth/accessible-tenants');
    return (response.data || response) as TenantAccessListResponseDTO;
  },

  // Switch current tenant context
  switchTenant: async (request: SwitchTenantRequestDTO): Promise<SwitchTenantResponseDTO> => {
    const response = await apiClient.post<SwitchTenantResponseDTO>('/auth/switch-tenant', request);
    return (response.data || response) as SwitchTenantResponseDTO;
  },

  // Refresh session context (reload roles, permissions, tenant access)
  refreshSessionContext: async (tenantId?: string): Promise<RefreshSessionContextResponseDTO> => {
    const response = await apiClient.post<RefreshSessionContextResponseDTO>(
      '/auth/refresh-context',
      {
        tenantId,
      }
    );
    return (response.data || response) as RefreshSessionContextResponseDTO;
  },

  // Validate current session
  validateSession: async (): Promise<{
    isValid: boolean;
    session?: UserSessionDTO;
    errors: string[];
    requiresRefresh: boolean;
  }> => {
    const response = await apiClient.post('/auth/validate-session', {
      includePermissions: true,
      refreshIfNeeded: false,
    });
    return (response.data || response) as {
      isValid: boolean;
      session?: UserSessionDTO;
      errors: string[];
      requiresRefresh: boolean;
    };
  },
};
